import React from 'react'
import PropTypes from 'prop-types'

import GeneralInputsSection from './sections/GeneralInputsSection'
// import AssumptionsSection from './sections/AssumptionsSection'
import StakeholderDetailsSection from './sections/StakeholderDetailsSection'

const SroiFormContent = ({ formik, stakeholderSectionInputsPreset }) => {
  return (
    <>
      <GeneralInputsSection formik={formik} />
      {/*Assumptions section is temporarily hidden*/}
      {/*<AssumptionsSection formik={formik} />*/}
      <StakeholderDetailsSection formik={formik} stakeholderSectionInputsPreset={stakeholderSectionInputsPreset} />
    </>
  )
}

SroiFormContent.propTypes = {
  formik: PropTypes.object.isRequired,
  stakeholderSectionInputsPreset: PropTypes.object
}

export default SroiFormContent
